import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ml_asset, use_slice_workspace } from '@/hooks/store/use_slices';
import { local_ml_asset_reservations_update_active } from '@/state/diffusion_models_ud/local_ml_asset_reservations_update_active';
import { local_generation_price_delete_generation_price_by_diffusion_model_id } from '@/state/generation_price/local_generation_price_delete_generation_price_by_diffusion_model_id';
import { store } from '@/state/store';
import { set_timeout } from '@/utils/utils_client';
import { DTO__ml_asset_reservation } from '@shared/dto/+model/reservation/DTO__ml_asset_reservation';
import { timestamp_ms } from '@shared/utils/utils_time';
import { useRef } from 'react';

export function WatcherDiffusionModelsReservationTimers() {
  const dispatch = use_dispatch();
  const { reservations_map_all } = use_slice_ml_asset(['reservations_map_all']);
  const { workspace_current } = use_slice_workspace(['workspace_current']);

  //key - diffusion_model_id, value - timeout_id
  const timeouts_ids_map = useRef(new Map<string, number>());

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (workspace_current.is_stub()) return;

    clear_all_timeouts();

    start_timeouts_for_active_reservations();

    return () => clear_all_timeouts();
  }, [reservations_map_all, workspace_current]);

  /*
   * METHODS
   */
  function clear_all_timeouts() {
    for (let timeout_id of timeouts_ids_map.current.values()) {
      clearTimeout(timeout_id);
    }

    timeouts_ids_map.current.clear();
  }

  function start_timeouts_for_active_reservations() {
    let time_now = timestamp_ms();

    for (let reservation of reservations_map_all.values()) {
      if (reservation.workspace_id != workspace_current._id) continue; //reservation from another workspace
      if (reservation.expired_at <= time_now) continue; //reservation already expired

      let time_left = Math.max(reservation.expired_at - time_now, 0);

      //just need re-upsert reservation to update reservations maps: active and expired
      set_timeout(() => delete_reservation(reservation), time_left);
    }
  }

  function delete_reservation(reservation: DTO__ml_asset_reservation) {
    dispatch(local_ml_asset_reservations_update_active(workspace_current._id));

    if (!is_model_have_other_active_reservations(reservation.diffusion_model_id)) {
      //we delete price data after expiration because next time when server will launch diffusion model its price could be changed because of different gpu price
      dispatch(local_generation_price_delete_generation_price_by_diffusion_model_id([reservation.diffusion_model_id]));
    }
  }

  function is_model_have_other_active_reservations(diffusion_model_id: string) {
    //use store to get actual info
    let { reservations_current_workspace_active_map } = store.getState().slice_ml_asset;

    return reservations_current_workspace_active_map.has(diffusion_model_id);
  }

  return <></>;
}
